import { Spinner, useAccessTokenManagement } from '@hbo/ui-servicing-react-components';
import { createContext, useCallback, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from 'types/global';

interface AuthenticationProviderProps {
  children: React.ReactNode | React.ReactNode[];
}

interface IssuePayload {
  baseUrl: string;
  clientId: string;
  token: string;
  brand: string;
  tokenType?: string;
  scope?: string[];
  redirectUri?: string;
  nonce?: string;
  state?: string;
}

interface AuthenticationProviderInterface {
  accessToken?: string | null;
  logout: (options?: { isError: boolean }) => void;
  isAuthenticated: boolean;
  isAuthenticating: boolean;
}

// @ts-ignore
export const AuthenticationContext = createContext<AuthenticationProviderInterface>();

function AuthenticationProvider({ children }: AuthenticationProviderProps) {
  const navigate = useNavigate();
  const { isAuthenticated, isAuthenticating, revokeToken } = useAccessTokenManagement();

  const getAccessToken = () => sessionStorage.getItem('access_token');
  const accessToken = getAccessToken();
  // const extcam = sessionStorage.getItem('extcam');

  useEffect(() => {
    window.digitalData = { ...window.digitalData, user: { authenticated: isAuthenticated } };
  }, [isAuthenticated]);

  const logout = useCallback(
    ({ isError = false }: { isError?: boolean } = {}) => {
      revokeToken();
      navigate(isError ? RoutePath.ServerError : RoutePath.LoggedOut, {
        state: { isLoggingOut: true }
      });
    },
    [revokeToken, navigate]
  );

  // check if it is relevant for things outside mss
  // if (extcam) {
  //   window.digitalData.page.query = {
  //     string: `?extcam=${extcam}`,
  //     parameters: [{ name: 'extcam', value: extcam }]
  //   };
  // }

  return (
    <AuthenticationContext.Provider
      value={{
        accessToken,
        isAuthenticated,
        isAuthenticating,
        logout
      }}
    >
      {isAuthenticating ? <Spinner message="Loading" isFullscreen isBranded /> : <>{children}</>}
    </AuthenticationContext.Provider>
  );
}

export default function useAuth() {
  return useContext(AuthenticationContext);
}

export { AuthenticationProvider };
